module.exports = __webpack_public_path__ + "static/media/discover_logo.e06ec557.png";